import React from "react";
import SteamConsumption from "./ConsumptionByFacility";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope2Layout from "../../../../Layout/Scope2Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const SteamFacility = () => {
  return (
    <MainDashboardLayout sidebar={<Scope2Layout />}>
      <Unauthorized requiredModule="Environment | Scope 2 | Steam">
        <SteamConsumption />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default SteamFacility;
